import PageHeader from "@/components/common/PageHeader";
import AccountSettings from "@/components/settings/AccountSettings";
import AppearanceSettings from "@/components/settings/AppearanceSettings";
import NotificationSettings from "@/components/settings/NotificationSettings";
import PrivacySettings from "@/components/settings/PrivacySettings";
import SecuritySettings from "@/components/settings/SecuritySettings";
import SettingsSidebar from "@/components/settings/SettingsSidebar";
import { useAuth } from "@/hooks/useAuth";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

const Settings = () => {
  const { t, i18n } = useTranslation();
  const { user, updateUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [activeSection, setActiveSection] = useState("account");

  const handleLanguageChange = async (language: "en" | "am" | "ti") => {
    try {
      setIsLoading(true);
      i18n.changeLanguage(language);
      await updateUser({
        language: language,
      });
      toast.success(t("settings.languageUpdated"));
    } catch (error) {
      console.error("Failed to update language:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderActiveSection = () => {
    switch (activeSection) {
      case "account":
        return <AccountSettings user={user} />;
      case "notifications":
        return <NotificationSettings user={user} />;
      case "language":
      case "theme":
        return (
          <AppearanceSettings
            user={user}
            onLanguageChange={handleLanguageChange}
            isLoading={isLoading}
          />
        );
      case "privacy":
        return <PrivacySettings user={user} />;
      case "security":
        return <SecuritySettings user={user} />;
      default:
        return <AccountSettings user={user} />;
    }
  };

  return (
    <div>
      <PageHeader
        title={t("settings.title")}
        description={t("settings.description")}
      />

      <div className="grid gap-6 md:grid-cols-3">
        <SettingsSidebar
          activeSection={activeSection}
          onSectionChange={setActiveSection}
        />
        
        <div className="md:col-span-2">
          {renderActiveSection()}
        </div>
      </div>
    </div>
  );
};

export default Settings;

